<template>
	<div class="wp-detail">
		<div v-if="intestazione" class="wp-head">
			<v-avatar size="20px" tile class="mr-1">
				<img :src="setting.logo" alt="Wallet" />
			</v-avatar>
			<span class="wp-head-title">Configurazione Wallet / Gift card</span>
			<span class="wp-muted ml-2">{{ modello.active ? 'attivo' : 'disattivato' }}</span>
		</div>

		<div class="wp-body">
			<v-alert outlined text dense type="info" class="text-body-2 mb-4">
				Attivando questa opzione sarà possibile acquistare nel sito la gift card. Il riscatto della gift card permetterà all'utente di usare un portafoglio virtuale da usare negli acquisti.
			</v-alert>

			<div class="wp-section">Titolo e testo della gift card</div>
			<div class="wp-texts mb-4">
				<v-tabs v-model="tab" show-arrows height="38" background-color="transparent" class="wp-tabs">
					<v-tab v-for="t in nomi" :key="t.lang" class="px-3">
						<v-avatar size="16px" tile class="mr-1"><img :src="getImageFlag(t.lang)" :alt="t.lang" /></v-avatar>
						{{ String(t.lang).toUpperCase() }}
						<span v-if="!t.name" class="wp-dot" />
					</v-tab>
				</v-tabs>
				<div v-if="nomi[tab]" :key="nomi[tab].lang" class="wp-tab-body">
					<v-text-field v-model="nomi[tab].name" label="Nome gift card" dense outlined hide-details background-color="white" class="mb-3"></v-text-field>
					<ckeditor v-if="testi[tab]" :editor="editor" v-model="testi[tab].text" :config="editorConfig"></ckeditor>
				</div>
			</div>

			<div class="wp-section">Importi</div>
			<v-combobox
				v-model="setting.amounts"
				:items="setting.amounts"
				label="Importi disponibili (scrivi e premi Invio)"
				multiple
				small-chips
				deletable-chips
				dense
				outlined
				hide-details
				background-color="white"
				class="mb-4"
				@change="$emit('normalize-amounts')"
			></v-combobox>

			<div class="wp-section">Immagini</div>
			<vue-dropzone
				id="dropzoneWalletImage"
				ref="walletDropzone"
				:options="dropzoneOptions"
				class="wp-dropzone mb-3"
				@vdropzone-complete="$emit('upload-complete', $event)"
				@vdropzone-sending="(file, xhr, formData) => $emit('sending', file, xhr, formData)"
			/>
			<div v-if="immagini.length" class="wp-muted wp-small mb-2">Trascina le immagini per cambiarne l'ordine: la prima è quella principale.</div>
			<!-- :value e non :list: lo spostamento lo applica la pagina sull'evento drop -->
			<draggable :value="immagini" tag="div" class="wp-images" :sort="true" @change="$emit('drop', $event)">
				<div v-for="(image, i) in immagini" :key="image.value + i" class="wp-image">
					<v-img :src="image.value" :lazy-src="image.value" height="110" contain></v-img>
					<span class="wp-image-num">{{ i + 1 }}</span>
					<v-btn x-small icon class="wp-image-remove" title="Rimuovi immagine" @click="$emit('remove-image', i)"><v-icon x-small>mdi-close</v-icon></v-btn>
				</div>
			</draggable>
		</div>

		<div class="wp-foot">
			<v-btn depressed small color="primary" @click="$emit('save')">Conferma</v-btn>
		</div>
	</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Draggable from 'vuedraggable';

// riquadro di configurazione del Wallet / Gift card: testi per lingua, importi e immagini.
// Il CKEditor e' registrato globalmente dalla pagina (Vue.use(CKEditor)).
export default {
	name: 'WalletPanel',
	components: { vueDropzone: vue2Dropzone, Draggable },
	props: {
		modello: { type: Object, required: true },
		editor: { type: Function, required: true },
		editorConfig: { type: Object, default: () => ({}) },
		dropzoneOptions: { type: Object, required: true },
		getImageFlag: { type: Function, required: true },
		intestazione: { type: Boolean, default: true },
	},
	data() {
		return { tab: 0 };
	},
	computed: {
		setting() {
			return this.modello.setting || {};
		},
		nomi() {
			return (this.setting.name && this.setting.name.trans) || [];
		},
		// stesso ordine di nomi (createWalletTrans li ordina entrambi per lingua)
		testi() {
			return (this.setting.text && this.setting.text.trans) || [];
		},
		immagini() {
			return this.setting.images || [];
		},
	},
};
</script>

<style scoped>
.wp-detail {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	width: 100%;
}
.wp-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.wp-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.wp-body {
	padding: 12px;
}
.wp-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.wp-muted {
	color: #5f6b7a;
}
.wp-small {
	font-size: 13px;
}
.wp-texts {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.wp-tabs {
	border-bottom: 1px solid #eef2f7;
}
.wp-tabs ::v-deep .v-tab {
	min-width: 0;
	font-size: 12px;
	letter-spacing: 0.03em;
}
.wp-dot {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: #f0a020;
	margin-left: 4px;
}
.wp-tab-body {
	padding: 10px;
}
.wp-dropzone {
	border-radius: 8px;
	border: 1px dashed #b8c4d4 !important;
	min-height: 110px;
}
.wp-images {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
	gap: 8px;
}
.wp-image {
	position: relative;
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	padding: 6px;
	cursor: grab;
}
.wp-image-num {
	position: absolute;
	top: 6px;
	left: 6px;
	font-size: 11px;
	font-weight: 600;
	background: rgba(255, 255, 255, 0.9);
	border: 1px solid #e1e7ef;
	border-radius: 4px;
	padding: 0 5px;
}
.wp-image-remove {
	position: absolute !important;
	top: 4px;
	right: 4px;
	background: rgba(255, 255, 255, 0.9);
}
.wp-foot {
	display: flex;
	justify-content: flex-end;
	padding: 8px 12px;
	background: #fff;
	border-top: 1px solid #e1e7ef;
}
@media (max-width: 768px) {
	.wp-body {
		padding: 8px;
	}
}
</style>
